import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
  Box,
  Alert
} from '@mui/material';

function PaymentModal({ open, onClose, bookingDetails, onPaymentComplete }) {
  const [paymentMethod, setPaymentMethod] = useState('bkash');
  const [paymentDetails, setPaymentDetails] = useState({
    phoneNumber: '',
    transactionId: ''
  });
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!paymentDetails.phoneNumber || !paymentDetails.transactionId) {
      setError('Please fill in all payment details');
      return;
    }
    onPaymentComplete(paymentDetails);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Payment Details</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1">
            Vehicle: {bookingDetails?.vehicleName}
          </Typography>
          <Typography variant="h6" color="primary" sx={{ mt: 1 }}>
            Total Amount: ৳{bookingDetails?.totalAmount}
          </Typography>
        </Box>

        <Box component="form" onSubmit={handleSubmit}>
          <RadioGroup
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            sx={{ mb: 3 }}
          >
            <FormControlLabel value="bkash" control={<Radio />} label="bKash" />
            <FormControlLabel value="nagad" control={<Radio />} label="Nagad" />
            <FormControlLabel value="rocket" control={<Radio />} label="Rocket" />
            <FormControlLabel value="bank" control={<Radio />} label="Bank Transfer" />
          </RadioGroup>

          <Box sx={{ bgcolor: 'grey.100', p: 2, borderRadius: 1, mb: 3 }}>
            <Typography variant="subtitle2" gutterBottom>
              Payment Instructions
            </Typography>
            <Typography variant="body2" gutterBottom>
              Merchant Number: 01712345678
            </Typography>
            <Typography component="div" variant="body2">
              Steps:
              <ol style={{ marginTop: 8, paddingLeft: 20 }}>
                <li>Go to bKash App or *247#</li>
                <li>Choose "Send Money"</li>
                <li>Enter merchant number: 01712345678</li>
                <li>Enter amount: ৳{bookingDetails?.totalAmount}</li>
                <li>Enter your PIN to confirm</li>
                <li>Save the Transaction ID</li>
                <li>Enter the Transaction ID below</li>
              </ol>
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <TextField
            fullWidth
            label="Phone Number"
            value={paymentDetails.phoneNumber}
            onChange={(e) => setPaymentDetails({
              ...paymentDetails,
              phoneNumber: e.target.value
            })}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Transaction ID"
            value={paymentDetails.transactionId}
            onChange={(e) => setPaymentDetails({
              ...paymentDetails,
              transactionId: e.target.value
            })}
            sx={{ mb: 3 }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            color="primary"
          >
            Verify Payment
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default PaymentModal; 